@if (isAnyClient()) {
  @if (isSingleClient()) {
    <ap-header-options-item [label]="selectedClient()?.label!" />
  } @else {
    <div class="dropdown-container">
      <gstar-combobox
        #clientCombobox
        [label]="'header.dropdown.defaultLabel' | translate"
        [options]="clientList()"
        [value]="selectedClient()"
        keyProp="label"
        valueProp="value"
        [disabled]="isDisabled()"
        (clearValue)="clearSelection()"
        (selectItem)="selectItem($event)">
      </gstar-combobox>
    </div>
  }
}
